import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Container, Grid } from "semantic-ui-react";
import { toast } from "react-toastify";
import _ from "lodash";
import cx from "classnames";

import { activateUser, fetchUser } from "actions/users";

import styles from "./detail.module.scss";

import Basic from "./Basic";
import Profile from "./Profile";
import Password from "./Password";
import ConfirmModal from "components/ui/ConfirmModal";
import { useState } from "react";
import { isAccountSuspended } from "components/features/Util/Util";
import Permission from "./Permission";
import { useParams} from "react-router-dom";



export default function UserDetail({ location, history, setGoBackPath }) {
  const dispatch = useDispatch();

  const { state } = location;
  const { id, accountId } = state;

  const [open, setOpen] = useState(false);
  const [initialRendering, setInitialRendering] = useState(true);

  const account = useSelector((state) => state.accounts.account);
  const user = useSelector((state) => _.get(state, "users.user"));
  const activatingUser = useSelector((state) =>
    _.get(state, "users.activatingUser")
  );

  const permissionData = useSelector((state) => _.get(state, "users.me.role"));
  const params = useParams();

  useEffect(() => {
    setGoBackPath(`/${params.product}/accounts/${accountId}/user_management`);
  }, []);

  useEffect(() => { 
    if(!user){
       dispatch(fetchUser({ id: id}));
    }
  }, []);

  useEffect(() => {
    if (!initialRendering && activatingUser) {
      if (!activatingUser.activating && activatingUser.success) {
        toast.success(
          ` ${user.enabled ? "Activated" : "Deactivated"} ${user.name}`
        );
      }
    }
  }, [activatingUser]);

  setTimeout(() => {
    setInitialRendering(false);
  }, [3000]);

  const onSaveChangesConfirm = () => {
    dispatch(activateUser({ id: user.id, enabled: !user.enabled }));
    setOpen(false);
  };

  const onCancelChanges = () => {
    setOpen(false);
  };

  const activateConfirmText = () => {
    let message = "";
    if (user) {
      message = `Are you sure want to ${
        user.enabled ? "Deactivate" : "Activate"
      }  ${user ? user.name : ""}?`;
    }

    return message;
  };

  return (
    <>
      <Container className={cx(styles.container)}>
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column width={7}>
              <Profile user={user} permissionData={permissionData} />
              <Basic user={user} permissionData={permissionData}/>
            </Grid.Column>
            <Grid.Column width={9}>
              <Password user={user} permissionData={permissionData}/>
            </Grid.Column>
          </Grid.Row>


          <Grid.Row columns={2}>
            <Grid.Column width={7}>
              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column width={10}>
                    <div className={cx(styles.text)}>
                      Would you like to deactivate this account?
                    </div>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    {user && user.enabled ? (
                      <Button
                        content="Deactivate"
                        onClick={() => setOpen(true)}
                        className={cx(styles.btn, styles.deactivate)}
                        disabled={isAccountSuspended(account) || !_.get(permissionData, 'user.write', false)}
                      />
                    ) : (
                      <Button
                        content="Activate"
                        onClick={() => setOpen(true)}
                        className={cx(styles.btn, styles.activate)}
                        disabled={isAccountSuspended(account) || !_.get(permissionData, 'user.write', false)}
                      />
                    )}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <ConfirmModal
          open={open}
          setOpen={setOpen}
          onSave={onSaveChangesConfirm}
          onCancel={onCancelChanges}
          content={activateConfirmText()}
        />
      </Container>
    </>
  );
}
